import { Col, Input, Layout, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { t } from 'i18next';
import React, { useState } from 'react';
import PrimaryButton from '../../../component/button/PrimaryButton';
import SecondaryButton from '../../../component/button/SecondaryButton';
import CompanyProfileCompletion from './CompanyProfile';
import UserProfile from './UserProfile';

const CompletionWithCompanyProfile = () => {
  const [tab, setTab] = useState(1);

  const handleNext = () => {
    setTab(2);
  }

  const handleBack = () => {
    setTab(1);
  }

  return (
    <>
      <div className='p-5 m-5 rounded-[10px] bg-[#FFFFFF]'>
        <div className='font-sans-bold text-[28px] text-black-100'>
          {t("LOGIN_COMPLETION:TITLE_PAGE")}
        </div>
        <div className='font-roboto-medium text-[16px] text-[#424242]'>
          {t("LOGIN_COMPLETION:SUB_TITLE_PAGE")}
        </div>
        <div className='w-1/2 mt-5'>
          <Row className='bg-[#F3F3F3] h-[52px] rounded-md'>
            <Col span={12}>
              <Row>
                <Col className='grid place-items-center h-[52px]' span={4}>
                  <div className={`border ${tab === 1 ? 'border-red-100 bg-red-100' : 'border-[#228B22] bg-[#228B22]'} rounded-full w-[36px] h-[36px] grid place-items-center`}>
                    <p className='font-sans text-xl font-semibold text-white-100'>1</p>
                  </div>
                </Col>
                <Col className='flex items-center' span={8}>
                  <p className={`font-sans text-xl font-bold ${tab === 1 ? 'text-red-100' : 'text-[#228B22]' }`}> User Profile </p>
                </Col>
                <Col className='flex items-center' span={12}>
                  <hr className={`border-2 w-full ${tab === 1 ? ' border-[#D7D7D7] border-dashed ' : 'border-[#228B22] border-solid'} `} />
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <Row>
                <Col className='grid place-items-center h-[52px]' span={4}>
                  <div className={`border rounded-full w-[36px] h-[36px] grid place-items-center ${tab === 1 ? 'bg-[#FFFFFF] border-[#FFFFFF]' : 'border-red-100 bg-red-100' }`}>
                    <p className={`font-sans text-xl font-semibold ${tab === 1 ? 'text-[#ACACAC]' : 'text-white-100'}`}>2</p>
                  </div>
                </Col>
                <Col className='flex items-center' span={20}>
                  <p className={`font-sans text-xl font-bold ${tab === 1 ? 'text-[#ACACAC]' : 'text-red-100'}`}> Company Profile </p>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>

        <div>
          <div className='font-roboto font-semibold text-[20px] mt-5'>
          {t("LOGIN_COMPLETION:TITLE_LAYOUT")}
          </div>
          <div className='font-roboto text-[16px] text-[#424242]'>
          {t("LOGIN_COMPLETION:SUB_TITLE_LAYOUT")}
          </div>
          {
            tab === 1 ? (
              <UserProfile />
            ) : (
              <CompanyProfileCompletion />
            )
          }
        </div>
      </div>
      <div className='flex flex-row-reverse gap-[16px] px-5 m-5'>
        {
          tab === 1 ? (
            <>
              <PrimaryButton action={handleNext} text={t("COMMON:NEXT")} />
              <SecondaryButton text={t("USER_DETAIL:CANCEL")} />
            </>
          ) : (
            <>
              <PrimaryButton text={t("USER_DETAIL:SAVE")} />
              <SecondaryButton action={handleBack} text={t("USER_DETAIL:BACK")} />
            </>
          )
        }
      </div>
    </>
  );
}

export default CompletionWithCompanyProfile;